// extracted by mini-css-extract-plugin
module.exports = {"jumbotron":"Jumbotron_jumbotron__1Ioyg","jumbotron_sm":"Jumbotron_jumbotron_sm__6Zta4","img_jumbotron":"Jumbotron_img_jumbotron__3oWg7"};